import React, {createContext, useContext, useEffect, useReducer, useState} from "react";
import {UserApi} from "../../../utils/UserApi";

const AuthContext = createContext(null);
const AuthProvider = ({children}) => {
    const [state, setState] = React.useState({
        status: 'non',
        error: null,
        user: null,
        loggedIn: false
    });
    const [loggedIn, setLoggedIn] = useState(false);

    const login = async (data, error,showMessage) => {
        setState({
            status: 'pending', error: null, user: null, loggedIn: false
        });
        const response = async (data) => {
            await showMessage();
            setLoggedIn(true);
            setState({
                status: 'success', error: null, user: data.data.user, loggedIn: true
            });
console.log(data.data.access_token);
            localStorage.setItem("token", data.data.access_token);
        }
        const innerError = (e) => {
            setState({
                status: 'non', error: true, user: null, loggedIn: false
            });
            error(e);
        }
        await UserApi.login(data, response, innerError);
    } // make a login request


    const checkUser = async () => {
        setState({
            status: 'pending', error: null, user: null, loggedIn: false
        });
        const response = (data) => {
            setLoggedIn(true);
            setState({
                status: 'success', error: null, user: data.data.user, loggedIn: true
            });
            localStorage.setItem("token", data.data.access_token);
        }
        const error = () => {
            localStorage.removeItem("token");
            setState({
                status: 'error', error: true, user: null, loggedIn: false
            });
        }
        await UserApi.check(response, error);
    }


    const logout = async () => {
        setState({
            status: 'pending', error: null, user: null, loggedIn: false
        });
        const response = (data) => {
            setLoggedIn(false);
            setState({
                status: 'success', error: null, user: null, loggedIn: false
            });
            localStorage.removeItem("token");
        }
        const error = () => {
            localStorage.removeItem("token");
            setLoggedIn(false);
            setState({
                status: 'error', error: true, user: null, loggedIn: false
            });
        }
        await UserApi.logout(response,error);


    } // clear the token in localStorage and the user data


    return (
        <AuthContext.Provider value={{state, login, logout, loggedIn, checkUser}}>
            {/*{state.status === 'pending' ? (*/}
            {/*    'Loading...'*/}
            {/*) : state.status === 'error' ? (*/}
            {/*    <div>*/}
            {/*        Oh no*/}
            {/*        <div>*/}
            {/*            <pre>{state.error.message}</pre>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*) : (*/}
            {/*    children*/}
            {/*)}*/}
            {children}
        </AuthContext.Provider>
    )
}


const useAuthState = () => {
    const state = useContext(AuthContext).state;
    const login = useContext(AuthContext).login;
    const logout = useContext(AuthContext).logout;
    const checkUser = useContext(AuthContext).checkUser;
    const isPending = state.status === 'pending';
    const isError = state.status === 'error';
    const isSuccess = state.status === 'success';
    const isAuthenticated = state.user && isSuccess;
    const user = state.user;
    return {
        ...state,
        login, logout, checkUser,
        isPending,
        isError,
        isSuccess,
        isAuthenticated,
        user
    }
}
const UserContext = createContext(null);


const initialize = {
    status: false,
    name: '',
    error: false,
    succeeded: false,
    loading: false,
};

export const types = {
    SET_LOGGED_IN: "LOGGED_IN",
    SET_LOGGED_OUT: "LOGGED_OUT"
};


const reducer = (state, action) => {
    switch (action.type) {
        case types.SET_LOGGED_IN:
            state = {
                ...state,
                loading: false,
                id: action.id,
                error: [],
                succeeded: true,
                status: true,
                name: action.name
            };
            break;
        case types.SET_LOGGED_OUT:
            state = {
                ...state,
                loading: false,
                id: action.id,
                error: action.errors,
                succeeded: false,
                status: false,
                name: ''
            };
            break;
        default:
            throw Error("100");


    }
    return state;
};

const UserProvider = ({children}) => {

    let [userState, userDispatch] = useReducer(reducer, initialize, () => initialize);
    const [state, setState] = useState(initialize);
    useEffect(() => {


    }, [state]);
    return (
        <UserContext.Provider value={{userState, userDispatch}}>
            {children}
        </UserContext.Provider>
    )
};



export {UserProvider};
// export {AuthProvider, useAuth};
export {AuthProvider, useAuthState, AuthContext};
